import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { user, token } = await authAPI.googleSession(sessionId);
        loginWithToken(user, token);
        // Clean URL hash before navigating
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Benvenuto, ${user.name}!`);
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Login con Google fallito");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-3 text-slate-600">
        <Loader2 className="w-8 h-8 animate-spin text-[#e86a24]" />
        <p className="text-sm font-medium">Accesso in corso…</p>
      </div>
    </div>
  );
}
